import RestingHeartRate from "./RestingHeartRate";

const RestingHeartRateController = async (app) => {
  app.get("/resting-heart-rate", async ({ res, locals }) => {
    res.body = <RestingHeartRate />;
  });
};

export default RestingHeartRateController;
